import { z } from 'zod';

export const workspaceRoles = ['owner', 'admin', 'member', 'viewer'] as const;
export const WorkspaceRole = z.enum(workspaceRoles);
export type WorkspaceRole = z.infer<typeof WorkspaceRole>;

/**
 * How someone stands in one workspace: the role they were given, or
 * 'visitor' - a staff member looking around an open workspace they have not
 * joined. A visitor views and comments, and nothing else.
 */
export type WorkspaceAccess = WorkspaceRole | 'visitor';

/** Mirrors WorkspaceMember::isAdmin()/canEdit() from the Laravel app. */
export const canEdit = (role: WorkspaceAccess) => role !== 'viewer' && role !== 'visitor';
export const isWorkspaceAdmin = (role: WorkspaceAccess) => role === 'owner' || role === 'admin';
/** In the workspace, rather than looking around an open one. */
export const hasJoined = (role: WorkspaceAccess) => role !== 'visitor';
